import React from 'react';
import director from '../../assests/img/director.jpg';

const DirectorMessage = () => {

    return (
        <>
            <div className='inner_top_about_us'>
                <div id="bg" className="data-typography-1 data-theme-1">
                    <div className="page-wraper">
                        <div className="page-content bg-white">
                            <div className="dz-bnr-inr dz-bnr-inr-sm style-1 text-center overlay-primary-dark">
                                <div className="coustom_container">
                                    <div className="dz-bnr-inr-entry">
                                        <div className="pheading">
                                            <h1>Director’s Message</h1>
                                        </div>
                                        <nav aria-label="breadcrumb" className="breadcrumb-row">
                                            <ul className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <a href="/">Home</a>
                                                </li>
                                                <li className="mx-2">
                                                    /
                                                </li>
                                                <li className="breadcrumb-item active" aria-current="page">
                                                    Director’s Message
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>


                            <section className="content-inner section-wrapper5 pt-5 pb-5">
                                <div className="coustom_container">
                                    <div className="row">
                                        <div
                                            className="col-xl-9 col-lg-6 m-b30 wow fadeInUp"
                                            data-wow-delay="0.4s"
                                        >
                                            <div id="pagedata" className="pagedata">
                                                <p>
                                                    <img style={{ paddingLeft: "15px", float: "right" }} src={director} alt="director" width="293" height="305" />
                                                    Welcome to Karamchand Memorial School, a nascent and budding yet passionate, purposeful and progressive place to study, where our pupils will discover a deep love for learning and respect for the tradition of scholarship, as well as an openness to fresh ideas and innovative ways of thinking. At KCMS we believe that success is a result of student’s enjoyment of academic enquiry and debate, and the enthusiasm their teachers have for their subject, it is also down to their curiosity and the interests they form outside of the timetabled curriculum. We strive to present the perfect opportunity for bright pupils to share and develop their thoughts and skills, to ultimately prepare them for a fulfilling and vibrant life after School.
                                                </p>
                                                <p>
                                                    The School’s sociable and inclusive nature will be characterised by the way in which pupils will support one another at daily peer-led events and also through their active participation in transforming the society and community they come from. Pupils will be taught to appreciate and learn from the knowledge and experiences of those around them, and to engage with current political, cultural and academic developments, within a safe and open environment.
                                                </p>
                                                <p>
                                                    At KCMS, we want every single pupil in our care to enjoy their time, and to flourish and to take advantage of all the opportunities available to them, and we take this responsibility extremely seriously. Underpinning all our work will be an excellent system of safeguarding and spiritual care centred around each child. Everyone is welcome, and all are valued and nurtured here.Beyond the classroom, we aim to foster the diverse range of hobbies and interests our pupils may have with an exciting and extensive extra- and cocurricular programme of vents. Two entire afternoons each week are dedicated to sport and extra curricular activities.
                                                </p>
                                                <p>
                                                    However, words can never truly convey the spirit and warmth to be found inside our walls, and so I would very much welcome you and your ward to visit our institution and to see for yourself what KCMS is all about. We are so looking forward to meeting you.
                                                </p>
                                            </div>
                                        </div>

                                        <div
                                            className="col-xl-3 col-lg-6 wow fadeInUp"
                                            data-wow-delay="0.2s"
                                        >
                                            <div className="bg-lgrey">
                                                <div className="subMenubg active">
                                                    <a href="about-us" target="_self" className="submenu">
                                                        About Us
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="our-inspiration"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Our Inspiration
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="history" target="_self" className="submenu">
                                                        History
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a className="submenu">
                                                        Messages
                                                    </a>
                                                    <div className="founder_link">
                                                        <div className="subMenubg">
                                                            <a href="founder-message" className="submenu">
                                                                Founder’s Message
                                                            </a>
                                                        </div>
                                                        <div className="subMenubg">
                                                            <a href="director-message" className="submenu">
                                                                Director’s Message
                                                            </a>
                                                        </div>
                                                        <div className="subMenubg">
                                                            <a href="patron-message" className="submenu">
                                                                Patron Message
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="our-aims" target="_self" className="submenu">
                                                        Our Aims
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="our-ethos"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Our Ethos
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="our-vision.html"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Our Vision
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>

                        {/* <button className="scroltop icon-up" type="button">
                            <i className="fas fa-arrow-up"></i>
                        </button> */}
                    </div>
                </div>
            </div >
        </>
    )
}

export default DirectorMessage;